import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { getFilteredLenderFormsByLender } from '@core/util/lenderForms';
import {
	getMortgageFinancialInstitutionLender,
	getMortgageName,
} from '@core/util/mortgage';
import { getOrdinal } from '@core/util/number';
import { PDFForms } from '@models/matter-form-data';
import {
	MatterMortgage,
	MatterMortgageLenderForm,
	MatterMortgageWithAssociations,
} from '@models/mortgage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterMortgageLenderFormsRepoService } from '@repos/matter-mortgage-lender-forms/matter-mortgage-lender-forms.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { startCase } from 'lodash';
import { ICON } from '@core/util/icon';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { AddLenderFormModalComponent } from '../add-lender-form-modal.component';
import { PillModes } from 'src/app/shared/atomic/atoms/pill/pill.component';
import { NavigationService } from '@services/nav/nav.service';
import { FinancialInstitutionLender } from '@models/lender';

@UntilDestroy()
@Component({
	selector: 'app-lender-forms-mortgage-card',
	templateUrl: 'lender-forms-mortgage-card.component.html',
	animations: [openClose(300)],
	standalone: false,
})
export class LenderFormsMortgageCardComponent implements OnInit {
	@Input() set mortgage(mortgage: MatterMortgageWithAssociations) {
		this.financialInstitution = getMortgageFinancialInstitutionLender(mortgage);

		this._mortgage = mortgage;
		if (mortgage) {
			this.title = startCase(getMortgageName(mortgage));
		}
	}

	public financialInstitution: FinancialInstitutionLender;
	public _mortgage: MatterMortgage;
	public ICON = ICON;
	public PDFForms = PDFForms;
	public baseRoute: string;
	public title: string;
	public pillModes = PillModes;

	public lenderForms;

	public get lenderWebsiteLink(): string {
		return (
			this.financialInstitution?.formsLink ??
			this.financialInstitution?.branch?.formsLink ??
			''
		);
	}

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private matterMortgageLenderFormRepoService: MatterMortgageLenderFormsRepoService,
		private nav: NavigationService,
	) {}

	ngOnInit() {
		this.baseRoute = UrlService.Matter_Documents_Forms(this.matterId);
		this.matterMortgageLenderFormRepoService
			.All({ mortgageId: this._mortgage.id })
			.pipe(untilDestroyed(this))
			.subscribe((lenderForms: Partial<MatterMortgageLenderForm>[]) => {
				// rome-ignore lint/suspicious/noExplicitAny: <explanation>
				this.lenderForms = getFilteredLenderFormsByLender(
					this._mortgage,
					lenderForms as any,
				);
			});
	}

	openLenderFormModal(mortgageId) {
		this.dialog.open(AddLenderFormModalComponent, {
			minHeight: '700px',
			data: { mortgageId, ordinalNumber: getOrdinal(this._mortgage?.priority) },
		});
	}

	goToMortgage() {
		this.nav.goToMatter_Mortgages_Mortgage(this.matterId, this._mortgage.id);
	}
}
